
<template>
  <v-app id="searchNttp">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Invoice line items</v-card-title>
      <v-simple-table dense>
         <tbody v-for="(nttpRecord,i) in searchNttp" :key="i">
           <tr @click="$router.reload('/syst/ref/nttp/onNttp/' + nttpRecord.nttp_encrid)">
             <td>{{nttpRecord.nttp_nr}}</td>
             <td>{{nttpRecord.nttptaal_oms}}</td>
           </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>   
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      searchNttp: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/nttp/searchNttp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchNttp"
          },
          searchNttp: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchNttp = res.data.searchNttp;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
};

</script> 
